export default __webpack_public_path__ + "static/media/AvatarV2.4e2032d9.glb";